import { API_ENDPOINT } from '@/constants'
import { Maybe } from '@/types'

export const notFoundPath = '/404'
export const homePath = '/home'
export const addCarPath = '/cars/add'
export const editCarPath = '/cars/:id'
export const addDealPath = '/deals/add'
export const editDealPath = '/deals/:id'
export const addProposalPath = '/deals/proposals/add'
export const editProposalPath = '/deals/proposals/:id'
export const addCustomerPath = '/customers/add'
export const editCustomerPath = '/customers/:id'
export const addDriverPath = '/cars/:carId/drivers/add'
export const editDriverPath = '/cars/:carId/drivers/:id'
export const addReportPath = '/reports/add'
export const editReportPath = '/reports/:id'
export const signInPath = '/sign-in'
export const searchedPath = '/:customerId'
export const mainInformationPath = 'main'
export const carsPath = 'cars'
export const dealsPath = 'deals'
export const reportsPath = 'reports'
export const driversPath = 'drivers'
export const invoicesPath = 'invoices'
export const proposalPath = 'proposal'

export const isActiveLink = (locationPath: string, path: string): boolean => {
  const _path = locationPath.split('/')

  return _path.includes(path)
}

export const generatePath = (
  path: string,
  params: { [x: string]: string | number | undefined | null } = {},
): string => {
  let newPath: string = path
  Object.keys(params).forEach(param => {
    newPath = newPath.replace(`:${param}`, `${params[param] || ''}`)
  })

  return newPath
}

interface IMakeSearchPath {
  customerId?: Maybe<number> | string | number
  id?: Maybe<number | string>
}

export const makeSearchPath = (path: string, data: IMakeSearchPath) => {
  return `/${data.customerId || 'customer'}/${path}${
    data.id ? `/${data.id}` : ''
  }`
}

export function openInNewTab(url: string) {
  const win = window.open(url, '_blank')
  win?.focus()
}

export function print(type: string, id?: string) {
  if (!id) return
  let _link = `${API_ENDPOINT}`
  if (type === 'proposal') {
    _link += `/deals/proposal/${id}/pdf/`
  } else if (type === 'report') {
    _link += `/reports/pdf/${id}/`
  } else if (type === 'invoice') {
    _link += `/payment/invoice/${id}/pdf/`
  }
  openInNewTab(_link)
}
